// extracted by mini-css-extract-plugin
export default {"treeWrapper":"TreeWrapper__treeWrapper--M0hHYrksk_irPLgWsn_7"};